package br.com.texeratx.boardgametimeapp.ui.screens.expansions.edit

import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.koinInject

class EditExpansionScreen(
    private val expansionId: Long
) : Screen {

    @Composable
    override fun Content() {
        val viewModel = koinInject<EditExpansionViewModel>()
        val state by viewModel.state.collectAsState()

        val snackbarHostState = remember { SnackbarHostState() }
        val navigator = cafe.adriel.voyager.navigator.LocalNavigator.currentOrThrow

        LaunchedEffect(expansionId) {
            viewModel.load(expansionId)
        }

        LaunchedEffect(state.uiMessage) {
            state.uiMessage?.let {
                snackbarHostState.showSnackbar(it)
                viewModel.consumeMessage()
            }
        }

        EditExpansionUI(
            state = state,
            snackbarHost = { SnackbarHost(snackbarHostState) },
            onBack = { navigator.pop() },
            onNameChange = viewModel::onNameChange,
            onImageUrlChange = viewModel::onImageUrlChange,
            onBggUrlChange = viewModel::onBggUrlChange,
            onGameSelected = viewModel::onGameSelected,
            onSave = {
                viewModel.save(
                    onSuccess = { navigator.pop() }
                )
            },
            onDismissError = viewModel::clearError
        )
    }
}
